import React from 'react';
import { useNavigate } from 'react-router-dom';
import ScrollReveal from './ScrollReveal';

export default function CompleteSolution() {
  const navigate = useNavigate();

  const handleServiceClick = (serviceId) => {
    navigate(`/ydelser/${serviceId}`);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section className="bg-[#111111] pt-10 pb-20 md:pt-14 md:pb-28 text-center select-none font-sans border-t border-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center">
        
        {/* Heading without Flanking Accent Triangles */}
        <ScrollReveal direction="up" duration={700}>
          <h2 className="font-light text-3xl md:text-5xl text-white tracking-tight uppercase">
            Den komplette løsning
          </h2>
        </ScrollReveal>

        {/* Subtitle */}
        <ScrollReveal direction="up" duration={700} delay={150}>
          <p className="mt-4 text-base md:text-lg font-light text-neutral-400 max-w-6xl leading-relaxed">
            Nu er det slut med at ringe rundt – hos Bust Byg tilbyder vi at løse hele opgaven.
          </p>
        </ScrollReveal>

        {/* Services Section */}
        <ScrollReveal direction="up" duration={800} delay={300} className="w-full">
          <div className="mt-12 w-full flex flex-col items-center gap-y-6 text-sm md:text-lg font-bold tracking-widest text-neutral-300 uppercase">
            
            {/* Primary Priority Service */}
            <button
              onClick={() => handleServiceClick('renovering')}
              className="w-full text-center hover:text-orange-500 transition-colors duration-200 cursor-pointer focus:outline-none"
            >
              Renovering af huse og lejligheder
            </button>
            
            {/* Secondary Service Line */}
            <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3 w-full max-w-7xl">
              <button
                onClick={() => handleServiceClick('murer')}
                className="hover:text-orange-500 transition-colors duration-200 cursor-pointer focus:outline-none"
              >
                Mureropgaver
              </button>
              <span className="inline-block w-2 h-2 bg-orange-500 transform rotate-45 shrink-0"></span>
              <button
                onClick={() => handleServiceClick('toemrer')}
                className="hover:text-orange-500 transition-colors duration-200 cursor-pointer focus:outline-none"
              >
                Tømreropgaver
              </button>
              <span className="inline-block w-2 h-2 bg-orange-500 transform rotate-45 shrink-0"></span>
              <button
                onClick={() => handleServiceClick('maler')}
                className="hover:text-orange-500 transition-colors duration-200 cursor-pointer focus:outline-none"
              >
                Maleropgaver
              </button>
            </div>
            
            {/* Tertiary Service Line */}
            <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3 w-full max-w-7xl pt-2">
              <button
                onClick={() => handleServiceClick('vvs')}
                className="hover:text-orange-500 transition-colors duration-200 cursor-pointer focus:outline-none"
              >
                VVS-opgaver
              </button>
              <span className="inline-block w-2 h-2 bg-orange-500 transform rotate-45 shrink-0"></span>
              <button
                onClick={() => handleServiceClick('handyman')}
                className="hover:text-orange-500 transition-colors duration-200 cursor-pointer focus:outline-none"
              >
                Handymanopgaver
              </button>
            </div>
            
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}
